import request from '../../axios';
import {IUserData} from './types';

const getUserCooperationAgreementData = async () => {
  const {data}: {data: IUserData} = await request.get(
    '/api/v2/store/sign-cooperation-agreement',
  );
  return data;
};

export default getUserCooperationAgreementData;
